export default {
  createMember: {
    url: "createMember",
    method: "POST",
  },
  createOrganization: {
    url: "createOrganization",
    method: "POST",
  },
  updateMember: {
    url: "updateMember",
    method: "POST",
  },
  updateOrganization: {
    url: "updateOrganization",
    method: "POST",
  },
  getUserByEmail: {
    url: "getUserByEmail",
    method: "POST",
  },
  createUser: {
    url: "createUser",
    method: "POST",
  },
  sendAccountNotification: {
    url: "sendAccountNotification",
    method: "POST",
  },
  getAccountSetupLink: {
    url: "getAccountSetupLink",
    method: "POST",
  },
  distributeCredits: {
    url: "distributeCredits",
    method: "POST",
  },
  deleteUser: {
    url: "deleteUser",
    method: "POST",
  },
  getJourneyGamesData: {
    url: "getJourneyGamesData",
    method: "POST",
  },
  getJourneyCompletionInfo: {
    url: "getJourneyCompletionInfo",
    method: "POST",
  },
  getUserLatestActivity: {
    url: "getUserLatestActivity",
    method: "POST",
  },
  handleSkodaUserLogin: {
    url: "handleSkodaUserLogin",
    method: "POST",
  },
};
